import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'
import { OpportunitiesListEmpty } from '@/features/opportunities/components/OpportunitiesListEmpty'
import { observer } from 'mobx-react-lite'
import { useFeatures } from '@/contexts/root-store-context'
import { type WorkspacePostingOpportunitiesViewModel } from '@/features/opportunities/workspace-postings-opportunities/WorkspacePostingOpportunitiesViewModel'
import { WorkspaceOpportunityListItemContainer } from '@/features/opportunities/workspace-postings-opportunities/components/WorkspaceOpportunitiesList/WorkspaceOpportunityListItem/WorkspaceOpportunityListItemContainer'
import { byDesign } from '@/infra/design'
import imgEmptyUrl from '@/assets/misc/img_empty.svg'
import LookingEmptyIllustration from '@/components/SpotIllustration/LookingEmptyIllustration'

export interface WorkspaceOpportunitiesListContainerProps {
  vm: WorkspacePostingOpportunitiesViewModel
}

export const WorkspaceOpportunitiesListContainer = observer(
  function WorkspaceOpportunitiesListContainer({
    vm,
  }: WorkspaceOpportunitiesListContainerProps) {
    return (
      <div>
        <div>
          {vm.opportunities.map((op) => (
            <WorkspaceOpportunityListItemContainer
              key={op.opportunityId}
              opportunityVm={op}
            />
          ))}
          {vm.showEmptyState && <OpportunitiesEmpty />}
        </div>
        <InfiniteScrollLoaderContainer scrollProvider={vm.searcher.scroller} />
      </div>
    )
  },
)

const OpportunitiesEmpty = observer(function OpportunitiesEmpty() {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <OpportunitiesListEmpty
      corporateMode={shellInfo.corporateMode}
      title="Looking a little empty?"
      imageSrc={imgEmptyUrl}
      illustration={byDesign(undefined, LookingEmptyIllustration)}
      subtitle={<>Check back again soon for more potential opportunities.</>}
    ></OpportunitiesListEmpty>
  )
})
